<template>

    <div>

        <v-overlay v-if="error500" opacity="50" z-index="99999">
            <v-alert :value="true" type="error">
              {{$t('connection.message.error.error_500')}}
            </v-alert>
        </v-overlay>

        <v-snackbar v-model="snackbar" bottom v-if="message != null" :color="message.type">
            {{ message.text }}
          <template v-slot:action="{ attrs }">
            <v-btn
                text
                v-bind="attrs"
                @click="snackbar = false"
            >
              {{$t('common.close') }}
            </v-btn>
          </template>
        </v-snackbar>

    </div>

</template>


<script>

import { sessionStore } from '@/store/pinia/sessionStore'

    export default {

      setup() {

        const session = sessionStore();

        return {
          // you can return the whole store instance to use it in the template
          session,
        }

      },

        data() {
            return {

                message: null,
                snackbar: false,
                error500: false,
                // Track if we're currently verifying session to prevent multiple logout attempts
                isVerifyingSession: false

            }
        },

        methods: {


            throwMessage: function(message = '', type = 'message', code = 200){

                var self = this;

                self.snackbar = false;
                self.message = {'text': message, 'type':type, 'code':code};
                self.snackbar = true;

            },

            // Verify session with server before forcing logout
            async verifySessionAndLogout(originalError = null){
                var self = this;

                // Prevent multiple simultaneous verification attempts
                if (self.isVerifyingSession) {
                    return;
                }

                // Don't verify if already logged out or logging out
                if (self.session.state === 'ready' || self.session.state === 'deauthenticating') {
                    return;
                }

                self.isVerifyingSession = true;

                try {
                    // Try to ping the server to verify if session is truly invalid
                    const response = await this.$http.get('/auth/ping', { skipInterceptor: true });

                    if (response.data.payload !== true) {
                        // Session is truly invalid, logout
                        self.session.signOut();
                    } else if (originalError) {
                        // Session is still valid → the 401 was specific to the failed request
                        // (e.g. cross-origin credentials issue, missing role). Surface it
                        // instead of swallowing silently.
                        const apiMessage = originalError.response?.data?.payload?.error
                            || originalError.response?.data?.payload?.message
                            || originalError.response?.data?.error
                            || originalError.response?.data?.message;
                        self.throwMessage(
                            'API Error #401 – ' + (apiMessage || originalError.response?.statusText || 'Unauthorized'),
                            'error',
                            401
                        );
                    }
                } catch (error) {
                    // If ping also fails with 401, definitely logout
                    if (error.response && error.response.status === 401) {
                        self.session.signOut();
                    }
                    // For other errors (network, etc.), don't force logout
                } finally {
                    // Only reset if we're not in logout process
                    if (self.session.state !== 'deauthenticating' && self.session.state !== 'ready') {
                        self.isVerifyingSession = false;
                    }
                }
            },


        },

        mounted: function () {

            var self = this;

            this.$http.interceptors.request.use(function (config) {

                self.$root.$emit('erp.com.start');

                // Do something before request is sent
                config.request_id = (new Date().getTime()).toString(16);
                return config;

            }, function (error) {

                // Do something with request error
                return Promise.reject(error);

            });

            this.$http.interceptors.response.use(function (response) {

                if (!response.config?.suppressToast) {
                    if (response.data.error != null) {
                        self.throwMessage(response.data.error, 'error', response.status);
                    } else if (response.data.message != null) {
                        self.throwMessage(response.data.message, 'message', response.status);
                    }
                }

                return response;

            }, function (error) {


              if(error.code === 'ERR_CANCELED'){return Promise.reject(error);}

                // Check if error handling should be skipped for this request
                const skipInterceptor = error.config && error.config.skipInterceptor === true;

                if(!skipInterceptor) {
                  if(error.response === undefined){
                    self.throwMessage(self.$t('connection.message.error.error_connection_server'),'error');
                  } else if(error.response.status === 401){
                    // Don't immediately logout - verify session first
                    // This prevents logout due to transient network issues or race conditions.
                    // Pass the original error so a toast can be shown when the session is
                    // still valid but the request itself was unauthorized.
                    self.verifySessionAndLogout(error);
                  } else {
                      // Extract error message from response data
                      const errorMessage = error.response.data?.payload?.error
                        || error.response.data?.error
                        || error.response.statusText;
                      self.throwMessage('API Error #'+error.response.status+' – '+errorMessage,'error');
                  }
                }

                return Promise.reject(error);

            });

        },

    }
</script>